import React from 'react';
import * as Panel2 from './panel';
import HtmlViewer from './HtmlViewer';
import * as Op from './cg/ops';
import {useAssetURLFromArtifact} from './useAssetFromArtifact';

const inputType = 'html-file' as const;

const PanelHTML: React.FC<Panel2.PanelProps<typeof inputType>> = props => {
  const inputNode = props.input.path;
  const assetResult = useAssetURLFromArtifact(inputNode, Op.opHtmlArtifact);
  if (assetResult.loading) {
    return <div></div>;
  } else {
    return <HtmlViewer src={assetResult.directUrl ?? undefined} />;
  }
};

export const Spec: Panel2.PanelSpec = {
  id: 'html',
  Component: PanelHTML,
  inputType,
};
